import { call, put, takeEvery } from 'redux-saga/effects';
// import Api from './'

// Crypto Redux States
import { dashboardTypes } from './actionTypes';
import {
  getFilterListSuccess,
  getFilterListFail,
  getFilterDataSuccess,
  getFilterDataFail,
} from './actions';

//Include Both Helper File with needed methods
import { getFilterList, getFilterData } from '../../helpers/dasboard_helper';

function* fetchFilterlist() {
  try {
    const response: Promise<any> = yield call(getFilterList);
    yield put(getFilterListSuccess(response));
  } catch (error) {
    yield put(getFilterListFail(error));
  }
}

function* fetchFilterData(data: any) {
  try {
    const response: Promise<any> = yield call(getFilterData, data.payload);
    yield put(getFilterDataSuccess(response));
  } catch (error) {
    yield put(getFilterDataFail(error));
  }
}

function* dashboardSaga() {
  yield takeEvery(dashboardTypes.GET_FILTER_LIST, fetchFilterlist);
  yield takeEvery(dashboardTypes.GET_FILTER_DATA, fetchFilterData);
}

export default dashboardSaga;
